import { useState } from 'react'
import { Link } from 'react-router-dom'

import { ReactComponent as CheckMarkIcon } from './CheckMark.svg'
import styles from './PaymentCompleteDialog.module.scss'
import { ReactComponent as RepeatIcon } from './repeat.svg'

const RegularContent = ({ handleEnableClick }) => {
  const [isLoading, setLoading] = useState()

  function handleTurnOnClick() {
    setLoading(true)
    handleEnableClick()
  }

  return (
    <>
      <div className={isLoading ? styles.contentLoading : styles.content}>
        <div className={styles.title}>
          <RepeatIcon />
          Turn on auto payments and pay %1 less
        </div>
        <p>
          We can save your bank account lorem ipsum dolor sit amet for future payments.
        </p>
        <p>Your account will be charged on every 5th of May</p>
      </div>
      <div className={styles.controls}>
        <Link to="/billing">
          <button className={styles.secondaryButton}>Cancel</button>
        </Link>
        <button onClick={handleTurnOnClick} className={styles.primaryButton}>
          Turn on
        </button>
      </div>
    </>
  )
}

const EnabledContent = ({ paymentMethodName }) => (
  <>
    <div className={styles.content}>
      <div className={styles.title}>
        <CheckMarkIcon />
        Auto payments are enabled!
      </div>
      <p>Your {paymentMethodName} will be charged on every 5th of May.</p>
    </div>
    <div className={styles.controls}>
      <Link to="/billing">
        <button className={styles.primaryButton}>OK</button>
      </Link>
    </div>
  </>
)

export const TurnOnAutoPayments = ({
  handleEnableClick,
  isEnabled,
  paymentMethodName
}) => (
  <div className={styles.dialog}>
    {isEnabled ? (
      <EnabledContent paymentMethodName={paymentMethodName} />
    ) : (
      <RegularContent handleEnableClick={handleEnableClick} />
    )}
  </div>
)
